import { render, staticRenderFns } from "./RequestPricingForm.vue?vue&type=template&id=55cfcf3e&"
import script from "./RequestPricingForm.vue?vue&type=script&lang=js&"
export * from "./RequestPricingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports